import { render, staticRenderFns } from "./TheTerms.vue?vue&type=template&id=0d53a4b4&scoped=true&"
import script from "./TheTerms.vue?vue&type=script&lang=js&"
export * from "./TheTerms.vue?vue&type=script&lang=js&"
import style0 from "./TheTerms.vue?vue&type=style&index=0&id=0d53a4b4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d53a4b4",
  null
  
)

export default component.exports